import Link from 'next/link';
import { Image, ValImage } from '@valbuild/next';

interface EventTeaserProps {
  title: string;
  eventSlug: string;
  date: string;
  eventImage: Image;
  isFutureEvent?: boolean;
  speakers?: string[];
}

const EventTeaser = ({
  title,
  eventSlug,
  date,
  speakers,
  eventImage,
  isFutureEvent = true,
}: EventTeaserProps) => {
  return (
    <div className={`relative h-full w-full flex flex-col`}>
      <div className={`relative h-full mb-[-50px]`}>
        <ValImage
          src={eventImage}
          alt={title}
          fill
          sizes={'1200px'}
          className="object-cover opacity-50 filter"
        />
      </div>
      <div
        className={`absolute text-blank-yellow bg-blank-black font-solina text-[16px] leading-[27.2px] tracking-[0.12em] bottom-[-100px] py-[24px] ${
          isFutureEvent
            ? 'w-full tablet:w-[481px] laptop:w-[481px] desktop:w-[481px]'
            : ' w-[90%] '
        } `}
      >
        <div className="font-[600] uppercase w-full">
          <Link href={eventSlug} legacyBehavior>
            {title}
          </Link>
        </div>
        <div className="text-[18px] leading-[2rem] tracking-[0.05em] w-full flex flex-col mt-8">
          <div>
            {new Date(date).toLocaleDateString('nb-NO', {
              year: 'numeric',
              month: 'long',
              day: '2-digit',
            })}
          </div>
          <div>{speakers?.join(', ')}</div>
        </div>
      </div>
    </div>
  );
};
export default EventTeaser;
